export const UPDATE_PAGE_DATA = "KPI_FEED_DETAILS_UPDATE_PAGE_DATA";
export const UPDATE_KPI_FEED_DATAS = "UPDATE_KPI_FEED_DATAS";
export const UPDATE_FILTER_SELECTED_VALUES =
  "KPI_FEED_DETAILS_UPDATE_FILTER_SELECTED_VALUES";
export const UPDATE_FILTER_AVAILABLE_VALUES =
  "KPI_FEED_DETAILS_UPDATE_FILTER_AVAILABLE_VALUES";
export const UPDATE_PAGE_DATA_LOADING = "UPDATE_PAGE_DATA_LOADING";
